module.exports = __webpack_public_path__ + "static/media/pricing-card-icon.4c3403fe.JPG";